export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    RECORD_AB_USED_ALL: function RECORD_AB_USED_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/record-ab-used/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    RECORD_AB_USED_CREATE: function RECORD_AB_USED_CREATE(data) {
      return request({
        url: '/api/record-ab-used/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    RECORD_AB_USED_DETAIL: function RECORD_AB_USED_DETAIL(id) {
      return request({
        url: '/api/record-ab-used/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    RECORD_AB_USED_UPDATE: function RECORD_AB_USED_UPDATE(data) {
      return request({
        url: '/api/record-ab-used/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    RECORD_AB_USED_DELETE: function RECORD_AB_USED_DELETE(id) {
      return request({
        url: '/api/record-ab-used/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    RECORD_AB_USED_SYNC: function RECORD_AB_USED_SYNC(data) {
      return request({
        url: '/api/record-ab-used/sync',
        method: 'post',
        data: data
      });
    }
  };
});